import styled, { css } from "styled-components";
import { MediaQueries } from "src/constants/MediaQueries";
import { Box } from "src/components/Box";

export const BoxColumnEl = styled(Box)`
  ${MediaQueries.screen.medium.minWidth} {
    display: flex;
    align-items: baseline;

    > div {
      flex: 1;

      :first-child {
        padding-right: ${(p) => p.theme.dimension.spacing.xl}px;
      }

      :only-child {
        flex: 0.5;
      }
    }
  }
`;

export const BoxButtonCtaEl = styled(Box)`
  ${MediaQueries.screen.medium.minWidth} {
    ${(p) =>
      p &&
      css`
        border-top: 2px solid ${p.theme.colors.borders.light};
        padding-top: ${p.theme.dimension.spacing.xl}px;
      `}
  }
`;

export const BoxColumnSectionEl = styled(BoxColumnEl)`
  margin-bottom: ${(p) => p.theme.dimension.spacing.l}px;

  ${MediaQueries.screen.medium.minWidth} {
    ${(p) =>
      css`
        margin-bottom: ${p.theme.dimension.spacing.xl}px;
        border-top: 2px solid ${p.theme.colors.borders.light};
        padding-top: ${p.theme.dimension.spacing.xl}px;
      `}
  }
`;

export const BoxRowSectionEl = styled(Box)`
  margin-bottom: ${(p) => p.theme.dimension.spacing.l}px;

  ${MediaQueries.screen.medium.minWidth} {
    ${(p) =>
      css`
        margin-bottom: ${p.theme.dimension.spacing.xl}px;
        border-top: 2px solid ${p.theme.colors.borders.light};
        padding-top: ${p.theme.dimension.spacing.xl}px;
      `}
  }
`;

export const BoxDropdownEl = styled(Box)`
  ${(props) => css`
    > div > div > div {
      font-family: ${props.theme.text.fontFamily.normal};
      font-size: ${props.theme.text.size.normal};
      border: 1px solid ${props.theme.colors.borders.active};

      :hover {
        background-color: ${props.theme.colors.background.white};
      }

      :focus {
        border: 1px solid ${props.theme.colors.borders.active};
        background-color: transparent;
      }
    }
  `}
`;

export const BoxInputEl = styled(Box)`
  ${(props) => css`
    input {
      font-family: ${props.theme.text.fontFamily.normal};
      font-size: ${props.theme.text.size.normal};
    }
  `}
`;
